import { render, staticRenderFns } from "./UrlGenerate.vue?vue&type=template&id=72a1b366&scoped=true"
import script from "./UrlGenerate.vue?vue&type=script&lang=js"
export * from "./UrlGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1b366",
  null
  
)

export default component.exports